import { createSlice } from "@reduxjs/toolkit";
import { getCustomerProductSchemes, getCustomerSchemes, getCustomerSchemesByID, getProductSchemes, getSchemeByID, getSchemes, getSchemesByID, postCustomerSchemes, schemeAdd, schemeDelete } from "./schemesAction";

const schemesSlice = createSlice({
  name: "schemes",
  initialState: {
    error: "",
    message: null,
    loading: false,
    schemeslist: [],
    model: false,
    error_msg: null,
    rowdata: {},
    listCount: 0,
    productSchemePayload: {
      retailer_id: "",
      product_id: "",
      unit_id: "",
      quantity: ""
    },
    productScheme: {
      loading: false,
      data: {},
    },
    schemeParams: {
      no_of_pages: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "code",
      sortOrder: "-",
    },
  },
  reducers: {
    SetSchemeParams: (state, action) => {
      return {
        ...state,
        schemeParams: action.payload,
      };
    },
    schemeDelete: (state) => {
      return {
        ...state,
        loading: false

      };
    },
    InputChangeValue: (state, action) => {
      return {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.value,
        },
      };
    },
    isModelVisible: (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          model: action.payload,
          rowdata: {},
        };
      } else {
        return {
          ...state,
          model: action.payload,
        };
      }
    },
    clearData: (state) => {
      return {
        ...state,
        error: "",
        message: null,
        loading: false,
        schemeslist: [],
        model: false,
        error_msg: null,
        rowdata: {},
        listCount: 0,
        productSchemePayload: {
          retailer_id: "",
          product_id: "",
          unit_id: "",
          quantity: ""
        },
        productScheme: {
          loading: false,
          data: {},
        },
        schemeParams: {
          no_of_pages: 0,
          page_size: 10,
          page: 1,
          search: "",
          currentSort: "code",
          sortOrder: "-",
        },
      };
    },

    apiError: (state, action) => {
      return {
        ...state,
        loading: false,
        error_msg: action.payload
      };
    },

  },
  extraReducers: (builder) => {
    builder
      .addCase(getSchemes.pending, (state, action) => {
        state.status = "getSchemes loading";
        state.loading = true;
      })
      .addCase(getSchemes.fulfilled, (state, action) => {
        var response = action.payload.response;
        state.status = "getSchemes succeeded";
        state.loading = false;
        var noofpages = Math.ceil(
          action.payload.count / state.schemeParams?.page_size
        );

        state.schemeslist = response.results;
        state.listCount = response.count;
        state.schemeParams = {
          ...state.schemeParams,
          no_of_pages: noofpages,
        };
      })
      .addCase(getSchemes.rejected, (state, action) => {
        state.status = "getSchemes failed";
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(schemeAdd.pending, (state, action) => {
        state.status = "schemeAdd loading";
        state.loading = true;
      })
      .addCase(schemeAdd.fulfilled, (state, action) => {
        state.status = "schemeAdd succeeded";
        state.loading = false
        state.model = action.payload.modal;
        state.message = action.payload.response;
        state.rowdata = {};
      }
      )
      .addCase(schemeAdd.rejected, (state, action) => {
        state.status = "schemeAdd failed";
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(schemeDelete.pending, (state, action) => {
        state.status = "schemeDelete loading";
        state.loading = true;
      })
      .addCase(schemeDelete.fulfilled, (state, action) => {
        state.status = "schemeDelete succeeded";
        state.loading = false
      }
      )
      .addCase(schemeDelete.rejected, (state, action) => {
        state.status = "schemeDelete failed";
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(getSchemesByID.pending, (state, action) => {
        state.status = "getSchemeByID loading";
        state.loading = true;
      })
      .addCase(getSchemesByID.fulfilled, (state, action) => {
        state.status = "getSchemeByID succeeded";
        state.loading = false
        state.model = true;
        state.rowdata = {
          ...action.payload,
        };
      }
      )
      .addCase(getSchemesByID.rejected, (state, action) => {
        state.status = "getSchemeByID failed";
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(getProductSchemes.pending, (state, action) => {
        state.status = "getProductSchemes loading";
        state.productScheme.loading = true;
      })
      .addCase(getProductSchemes.fulfilled, (state, action) => {
        state.status = "getProductSchemes succeeded";
        state.productScheme.loading = false
        state.model = true;
        state.productScheme.data = action.payload
      }
      )
      .addCase(getProductSchemes.rejected, (state, action) => {
        state.status = "getProductSchemes failed";
        state.productScheme.loading = false;
        state.error = action.error.message;
      })
      .addCase(getCustomerProductSchemes.pending, (state, action) => {
        state.status = "getCustomerProductSchemes loading";
        state.productScheme.loading = true;
      })
      .addCase(getCustomerProductSchemes.fulfilled, (state, action) => {

        console.log(action.payload)
        state.status = "getCustomerProductSchemes succeeded";
        state.productScheme.loading = false
        state.model = true;
        state.productScheme.data = action.payload
      }
      )
      .addCase(getCustomerProductSchemes.rejected, (state, action) => {
        state.status = "getCustomerProductSchemes failed";
        state.productScheme.loading = false;
        state.error = action.error.message;
      })
      .addCase(postCustomerSchemes.pending, (state, action) => {
        state.status = "postCustomerSchemes loading";
        state.loading = true;
      })
      .addCase(postCustomerSchemes.fulfilled, (state, action) => {
        state.status = "postCustomerSchemes succeeded";
        state.loading = false
        state.model = action.payload.modal;
        state.message = action.payload.response;
        state.rowdata = {};
      }
      )
      .addCase(postCustomerSchemes.rejected, (state, action) => {
        state.status = "postCustomerSchemes failed";
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(getCustomerSchemes.pending, (state, action) => {
        state.status = "getCustomerSchemes loading";
        state.loading = true;
      })
      .addCase(getCustomerSchemes.fulfilled, (state, action) => {
        state.status = "getCustomerSchemes succeeded";
        state.loading = false;
        var response = action.payload.response;
        // var list = [];
        // if (state.schemeParams?.page == 1) {
        //   list = response.results;
        // } else {
        //   list = [...state.schemeslist, ...response.results];
        // }
        var noofpages = Math.ceil(
          action.payload.count / state.schemeParams?.page_size
        );

        state.schemeslist = response.results;
        state.listCount = response.count;
        state.schemeParams = {
          ...state.schemeParams,
          no_of_pages: noofpages,
        };
      }
      )
      .addCase(getCustomerSchemes.rejected, (state, action) => {
        state.status = "getCustomerSchemes failed";
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(getCustomerSchemesByID.pending, (state, action) => {
        state.status = "getCustomerSchemesByID loading";
        state.loading = true;
      })
      .addCase(getCustomerSchemesByID.fulfilled, (state, action) => {
        state.status = "getCustomerSchemesByID succeeded";
        state.loading = false
        state.model = true;
        state.rowdata = {
          ...action.payload,
        };
      }
      )
      .addCase(getCustomerSchemesByID.rejected, (state, action) => {
        state.status = "getCustomerSchemesByID failed";
        state.loading = false;
        state.error = action.error.message;
      })

  }

});
export const {
  InputChangeValue,
  apiError,
  isModelVisible,
  SetSchemeParams,
  clearData,
} = schemesSlice.actions;

export default schemesSlice.reducer;
